<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('xbsg.wdsg')}}</div>
        </div>
        <div class="cotainer subscriptionList">
            <ul class="ul-box">
                <li class="li"  v-for="(item, index) in list" :key="index">
                    <div class="li-head">
                        <div class="t1"><span>{{$t('xbsg.bz')}}</span> {{item.currency}}</div>
                        <div class="t2 active" v-if="item.status == 0">{{$t('xbsg.shz')}}</div>
                        <div class="t2" v-else-if="item.status == 1">{{$t('xbsg.ytg')}}</div>
                        <div class="t2" v-else>{{$t('xbsg.wtg')}}</div>
                    </div>
                    <div class="time"><span>{{$t('xbsg.sgrq')}}</span> {{item.buy_time_format}}</div>
                    <div class="item-box">
                        <div class="item">
                            <div class="t1">{{$t('xbsg.sgsl')}}</div>
                            <div class="t2">{{item.buy_amount}} {{item.currency}}</div>
                        </div>
                        <div class="item">
                            <div class="t1 center">{{$t('xbsg.tgsl')}}</div>
                            <div class="t2 center">{{item.true_amount}} {{item.currency}}</div>
                        </div>
                        <div class="item">
                            <div class="t1 text-right">{{$t('xbsg.ssrq')}}</div>
                            <div class="t2 text-right">{{item.start_time_format}}</div>
                        </div>
                    </div>
                </li>
                <!-- <li class="li">
                    <div class="li-head">
                        <div class="t1"><span>{{$t('xbsg.bz')}}</span> ODE</div>
                        <div class="t2">{{$t('xbsg.wtg')}}</div>
                    </div>
                    <div class="time"><span>{{$t('xbsg.sgrq')}}</span> 2023-05-21 10:02:05</div>
                    <div class="item-box">
                        <div class="item">
                            <div class="t1">{{$t('xbsg.sgsl')}}</div>
                            <div class="t2">3 ODE</div>
                        </div>
                        <div class="item">
                            <div class="t1 center">{{$t('xbsg.tgsl')}}</div>
                            <div class="t2 center">2 ODE</div>
                        </div>
                        <div class="item">
                            <div class="t1 text-right">{{$t('xbsg.ssrq')}}</div>
                            <div class="t2 text-right">2023-05-21 10:02:05</div>
                        </div>
                    </div>
                </li> -->
            </ul>
            <!-- 暂无数据 -->
            <div class="null-box" v-show="isNoData">
                <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                <p class="text">{{$t('zwsj.title')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'subscriptionList',
    data () {
        return {
            isNoData: true,
            list: [],
            isGoTOP: false,
            curDataLength: 10,
            theme: false,
            page: 1
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      this.getMyNewcoins()
    },
    methods: {
       back(){
           this.$router.push('/subscription')
       },
       getMyNewcoins(){
          let params = {
            page: this.page
          }
          this.$ajax.get('/web/getMyNewcoins',{params}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                // this.$toast.center(res.data.message);
                setTimeout(()=>{
                  this.$router.push('/login');
                },1000)
                return false
              }
              if(resData.length > 0){
                this.list = this.list.concat(resData);
                this.curDataLength = resData.length;
              }else{
                  this.curDataLength = resData.length;
              }
              if(this.list.length > 0){
                  this.isNoData = false;
              }else{
                  this.isNoData = true;
              }
            }).catch(function(err){
                console.log(err)
            })
       }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .ul-box .li{
      margin: .36rem .36rem 0;
      padding: .66rem .3rem;
      border-radius: .26rem;
      background: #fff;
  }
  .ul-box .li .li-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #3F3F3F;
      font-size: .36rem;
  }
  .ul-box .li .li-head .t2.active{
      color: #588bf8;
  }
  .ul-box .li .time{
      padding: .42rem 0;
      color: #8A8A8A;
      font-size: .36rem;
  }
  .ul-box .li .type-box .text{
      display: inline-block;
      margin-right: .24rem;
      padding: .12rem .42rem;
      font-size: .36rem;
      border-radius: .12rem;
  }
  .ul-box .li .type-box .t1{
      color: #123F7D;
      background: #DFEDFF;
  }
  .ul-box .li .type-box .t2{
      color: #fff;
      background: #FA0000;
  }
  .ul-box .li .item-box{
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: .3rem;
  }
  .ul-box .li .item-box .item .t1{
      color: #8A8A8A;
      font-size: .36rem;
  }
  .ul-box .li .item-box .item .t2{
      padding-top: 10px;
      color: #000;
      font-size: .36rem;
  }
  .ul-box .li .item-box .item .center{
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/subscriptionList.vue